export default "__VITE_ASSET__DUww4lc4__"